import styled from "styled-components";
import theme from "../../Styles/theme";

export const Container = styled.div``;

interface InputProps {
  focus: boolean;
}
export const Input = styled.input<InputProps>`
  width: 95%;
  padding: 0.2vw 1vw;
  font-size: 18px;
  font-size: max(1vw, 12px);

  border-width: 0;
  border-bottom: 1px solid
    ${({ focus }) => (focus ? theme.colors.primary : theme.colors.dark)};

  color: ${({ focus }) => (focus ? theme.colors.primary : theme.colors.dark)};

  background-color: ${theme.colors.secondary};

  margin-left: 1vw;
`;

export const InputDiv = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
`;

export const ErrorDiv = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
  justify-content:center;
`;
export const ErrorSpan = styled.span`
  color: ${theme.colors.attention};
  font-size: max(0.8vw, 10px);
`;
